/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import './BallsContainer.scss';
import Icon from 'src/components/Icon/Icon';

interface NumberProps {
  type: string,
  number: number,
  isBanker: boolean,
  color:string
}

interface LottoNumberProps {
  anyNumbers: NumberProps[],
  sameBallset: boolean,
  big?: boolean
}

function BallsContainer({ anyNumbers, sameBallset=false, big=false }: LottoNumberProps) {
  const bonusIndex =
  _.findIndex(anyNumbers, { type: 'ball' }) > -1
    ? _.findIndex(anyNumbers, { type: 'bonus' })
    : -1;

  return (
    <>
      {
        _.map(anyNumbers, (number, index) => {

          let typeOfBall = number.type;
          if (number.type === 'bonus' && sameBallset){
            typeOfBall = 'ball';
          } else if (number.type=== 'bonus' && !sameBallset){
            typeOfBall = 'star';
          }

          return (
            <Fragment key={ index }>
              <div
                key={ index }
                className={
                  classNames({
                    'balls-container__ball': typeOfBall === 'ball',
                    [`balls-container__ball--${ number.color?.toLowerCase() }`]:typeOfBall === 'ball',
                    'balls-container__ball--selected': typeOfBall === 'ball',
                    'balls-container__star balls-container__star--selected':typeOfBall === 'star',
                    'balls-container__ball--banker': number.isBanker,
                    'balls-container__ball--big': big,
                    'balls-container__star--big': big
                  })
                }
              >
                {
                  typeOfBall === 'ball' ? number.number :
                    (
                      <>
                        <div className={
                          classNames({
                            'balls-container__star-value': true,
                            'balls-container__star-value--big': big
                          })
                        }
                        >{ number.number }</div>
                        <Icon icon="star" />
                      </>
                    )
                }
              </div>
              {
                +index + 1 === bonusIndex && (
                  <Icon
                    className={
                      classNames({
                        'number-bet__plus number-bet__plus--quick-bet': true,
                        'balls-container__plus--big' : big
                      })
                    }
                    icon="more"
                  />
                )
              }
            </Fragment>
          );
        })
      }
    </>
  );
}

export default BallsContainer;
